import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollPositionRestore = () => {
  const location = useLocation();
  const previousPathnameRef = useRef(location.pathname);

  // restore scroll position on navigation
  useEffect(() => {
    if (previousPathnameRef.current !== location.pathname) {
      window.scrollTo(0, 0);
      previousPathnameRef.current = location.pathname;
    }
  }, [location]);

  return null;
};

export default ScrollPositionRestore;
